import React from 'react';
import AffiliateLink from './AffiliateLink';

const GuaranteeBadge = ({ className = '' }) => {
  return (
    <AffiliateLink className={`block ${className}`}>
      <div className="inline-flex flex-col items-center bg-gradient-to-br from-yellow-100 to-yellow-200 border-4 border-yellow-500 rounded-full p-6 shadow-xl w-48 h-48 justify-center">
        <div className="text-yellow-700 text-xs font-bold uppercase tracking-wider">100% Satisfaction</div>
        <div className="text-3xl font-black text-gray-800">60 DAY</div>
        <div className="text-lg font-bold text-gray-700">MONEY BACK</div>
        <div className="text-lg font-bold text-gray-700">GUARANTEE</div>
        <div className="text-yellow-600 text-2xl mt-1">✓</div>
      </div>
    </AffiliateLink>
  );
};

export default GuaranteeBadge;